import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Routing from './Routing';
import {BrowserRouter} from "react-router-dom";
import Auth0ProviderWithHistory from "./Services/auth0-provider-with-history";

import 'bootstrap/dist/css/bootstrap.min.css';

// noinspection SpellCheckingInspection,JSCheckFunctionSignatures
ReactDOM.render(
    <React.StrictMode>
        <Auth0ProviderWithHistory>
            <BrowserRouter>
                <Routing />
            </BrowserRouter>
        </Auth0ProviderWithHistory>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
